/**
 * Pasos para exportar un crucigrama
 * 1. Generar el crucigrama en https://www.educima.com/crosswordgenerator.php
 * 2. En la página que se abre, copiar del DOM el elemento con id="crossword"
 * 3. Eliminar las etiquetas <table>, <tbody>
 * 4. Sustitutir las etiquetas <td> y <div> por <div>
 * 5. Sustituir las clases 'square' por 'square' y 'crossword-row' por 'row'
 * 6. Reemplazar en el elemento los siguientes atributos
 * 6.1 Reemplazar 'class' por 'className'
 * 6.1 Reemplazar disabled="" por vacio
 * 6.2 Ajustar el 'style' en react 'style={{ textAlign: 'center' }}'
 * 6.3 Reemplazar 'maxLength={1}' por 'maxLength={1} onKeyDown={handleOnKeyDown}'
 */

import { handleOnKeyDown } from 'utils/crosswords.utils';

export const Crossword12 = (
    <div className="center crossword" id="crossword" style={{ textAlign: 'center' }}>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                    placeholder=""
                />
                <span className="num">1</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num">2</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="13"
                    data-across="12"
                    data-down="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num">3</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="J"
                    data-num="10"
                    data-across="9"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num">4</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="10"
                    data-across="9"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="10"
                    data-across="9"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="10"
                    data-across="9"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="10"
                    data-across="9"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="G"
                    data-num="10"
                    data-across="9"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="12"
                    data-across="9"
                    data-down="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="10"
                    data-across="9"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="6"
                    data-across="undefined"
                    data-down="7"
                    placeholder=""
                />
                <span className="num">5</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="K"
                    data-num="6"
                    data-across="undefined"
                    data-down="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num">6</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="7"
                    data-across="6"
                    data-down="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="8"
                    data-across="6"
                    data-down="9"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="6"
                    data-across="undefined"
                    data-down="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="6"
                    data-across="undefined"
                    data-down="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="6"
                    data-across="undefined"
                    data-down="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="2"
                    data-across="1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num">7</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="2"
                    data-across="1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="2"
                    data-across="1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="2"
                    data-across="1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="2"
                    data-across="1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="6"
                    data-across="1"
                    data-down="7"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="2"
                    data-across="1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="2"
                    data-across="1"
                    data-down="2"
                    placeholder=""
                />
                <span className="num">8</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="2"
                    data-across="1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="1"
                    data-across="undefined"
                    data-down="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="W"
                    data-num="0"
                    data-across="-1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num">9</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="H"
                    data-num="0"
                    data-across="-1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="3"
                    data-across="-1"
                    data-down="4"
                    placeholder=""
                />
                <span className="num">10</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="0"
                    data-across="-1"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="1"
                    data-across="-1"
                    data-down="2"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="3"
                    data-across="undefined"
                    data-down="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num">11</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="H"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="5"
                    data-across="4"
                    data-down="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="3"
                    data-across="undefined"
                    data-down="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="11"
                    data-across="undefined"
                    data-down="12"
                    placeholder=""
                />
                <span className="num">12</span>
            </div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num">13</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="9"
                    data-across="8"
                    data-down="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="11"
                    data-across="undefined"
                    data-down="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="3"
                    data-across="undefined"
                    data-down="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="11"
                    data-across="undefined"
                    data-down="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="3"
                    data-across="undefined"
                    data-down="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num">14</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="11"
                    data-across="3"
                    data-down="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="Z"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="4"
                    data-across="3"
                    data-down="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    data-num="11"
                    data-across="undefined"
                    data-down="12"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="3"
                    data-across="undefined"
                    data-down="4"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
        <tr className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </tr>
    </div>
);
